/* BV Mobile UX - Borgovitto 2026
 * 1. Page fade-in + loading bar
 * 2. Scroll reveal animations
 * 3. Bottom navigation: Menu | Cerca | Preferiti | Carrello
 * 4. Menu panel full-screen minimal 2026
 * 5. Haptic feedback
 * 6. Skeleton shimmer
 */
(function () {
  'use strict';

  if (window.innerWidth >= 750) return;

  /* CSS */
  var s = document.createElement('style');
  s.textContent =
    '@keyframes bvPI{from{opacity:0}to{opacity:1}}' +
    'body{animation:bvPI .3s ease both}' +
    '#bv-lb{position:fixed;top:0;left:0;height:2px;width:0;background:#000;z-index:999999;border-radius:0 2px 2px 0;transition:width .38s ease,opacity .25s ease;opacity:0;pointer-events:none}' +
    '#bv-lb.on{opacity:1}' +
    '.bv-rv{opacity:0;transform:translateY(20px);transition:opacity .5s ease,transform .5s ease}' +
    '.bv-rv.bv-in{opacity:1;transform:translateY(0)}' +
    '.bv-rv:nth-child(2){transition-delay:.06s}' +
    '.bv-rv:nth-child(3){transition-delay:.12s}' +
    '.bv-rv:nth-child(4){transition-delay:.18s}' +
    '.bv-rv:nth-child(n+5){transition-delay:.22s}' +
    '@keyframes bvSk{0%{background-position:200% 0}100%{background-position:-200% 0}}' +
    '.bv-sk{background:linear-gradient(90deg,#f0f0f0 25%,#e6e6e6 50%,#f0f0f0 75%);background-size:200% 100%;animation:bvSk 1.4s infinite}' +
    '#bv-bn{position:fixed!important;bottom:0!important;left:0!important;right:0!important;z-index:2147483647!important;background:#fff;transform:translateZ(0);-webkit-transform:translateZ(0);border-top:1px solid rgba(0,0,0,.07);display:grid;grid-template-columns:repeat(4,1fr);height:68px;padding-bottom:env(safe-area-inset-bottom,0px);box-shadow:0 -1px 0 rgba(0,0,0,.06),0 -6px 24px rgba(0,0,0,.11),0 -20px 48px rgba(0,0,0,.07)}' +
    '.bv-bn-a{display:flex;flex-direction:column;align-items:center;justify-content:center;gap:4px;text-decoration:none;color:rgba(0,0,0,.35);-webkit-tap-highlight-color:transparent;transition:color .15s,transform .12s;font-size:9px;font-weight:700;text-transform:uppercase;letter-spacing:.8px;position:relative;background:none;border:none;cursor:pointer;padding:0}' +
    '.bv-bn-a.cur{color:#000}' +
    '.bv-bn-a:active{color:#000;transform:scale(.9)}' +
    '.bv-bn-a svg{width:26px;height:26px}' +
    '.bv-bn-a.cur::after{content:"";position:absolute;bottom:4px;width:4px;height:4px;border-radius:50%;background:#000}' +
    '.bv-bn-b{position:absolute;top:5px;right:calc(50% - 19px);background:#000;color:#fff;font-size:9px;font-weight:700;min-width:16px;height:16px;border-radius:8px;padding:0 3px;display:none;align-items:center;justify-content:center;line-height:1;border:1.5px solid #fff}' +
    '.bv-bn-b.on{display:flex}' +
    'body.bv-nb{padding-bottom:calc(68px + env(safe-area-inset-bottom,0px))!important}' +
    'body.bv-nb #bv-sticky-bar{bottom:calc(68px + env(safe-area-inset-bottom,0px))!important}' +
    '#bv-menu{position:fixed;inset:0;z-index:10001;background:#fff;transform:translateY(100%);transition:transform .42s cubic-bezier(.25,.46,.45,.94);display:flex;flex-direction:column;overflow:hidden}' +
    '#bv-menu.open{transform:translateY(0)}' +
    '#bv-menu-hd{display:flex;align-items:center;justify-content:space-between;padding:22px 24px 18px;flex-shrink:0;border-bottom:1px solid rgba(0,0,0,.07)}' +
    '#bv-menu-logo{font-size:13px;font-weight:800;letter-spacing:3px;text-transform:uppercase;color:#000;text-decoration:none}' +
    '#bv-menu-close{width:36px;height:36px;border:none;background:rgba(0,0,0,.05);border-radius:50%;display:flex;align-items:center;justify-content:center;cursor:pointer;-webkit-tap-highlight-color:transparent;font-size:16px;color:#000}' +
    '#bv-menu-body{flex:1;overflow-y:auto;-webkit-overflow-scrolling:touch;overscroll-behavior:contain;padding-bottom:calc(40px + env(safe-area-inset-bottom,0px))}' +
    '.bv-mi{display:flex;align-items:center;justify-content:space-between;padding:0 24px;min-height:56px;border-bottom:1px solid rgba(0,0,0,.05);-webkit-tap-highlight-color:transparent;cursor:pointer;text-decoration:none}' +
    '.bv-mi-lbl{font-size:13px;font-weight:400;text-transform:uppercase;letter-spacing:3.5px;color:#000;line-height:1}' +
    '.bv-mi-ico{font-size:14px;color:rgba(0,0,0,.2);transition:transform .2s;line-height:1}' +
    '.bv-mi.expanded .bv-mi-ico{transform:rotate(45deg)}' +
    '.bv-sub{max-height:0;overflow:hidden;transition:max-height .35s ease;background:#f9f9f9}' +
    '.bv-sub.open{max-height:700px}' +
    '.bv-sub-a{display:block;padding:11px 24px 11px 32px;font-size:11px;font-weight:700;text-transform:uppercase;letter-spacing:1.8px;color:rgba(0,0,0,.55);text-decoration:none;border-bottom:1px solid rgba(0,0,0,.04);-webkit-tap-highlight-color:transparent}' +
    '.bv-sub-a:active{background:rgba(0,0,0,.04)}' +
    '.bv-mf{padding:28px 24px 0}' +
    '.bv-mf-a{display:block;font-size:10px;font-weight:700;text-transform:uppercase;letter-spacing:1.5px;color:rgba(0,0,0,.3);text-decoration:none;padding:8px 0;-webkit-tap-highlight-color:transparent}' +
    '#bv-menu-bd{position:fixed;inset:0;z-index:10000;background:rgba(0,0,0,0);pointer-events:none;transition:background .3s}' +
    '#bv-menu-bd.on{background:rgba(0,0,0,.3);pointer-events:all}' +
    '#bv-sb{position:fixed;bottom:calc(68px + env(safe-area-inset-bottom,0px));left:0;right:0;z-index:2147483646;background:#fff;padding:12px 16px 14px;border-top:1px solid rgba(0,0,0,.07);box-shadow:0 -4px 20px rgba(0,0,0,.08);transform:translateY(110%);transition:transform .32s cubic-bezier(.25,.46,.45,.94);display:flex;align-items:center;gap:10px}' +
    '#bv-sb.open{transform:translateY(0)}' +
    '#bv-sb-inp{flex:1;height:46px;border:1.5px solid rgba(0,0,0,.1);border-radius:4px;padding:0 14px;font-size:16px;font-family:inherit;outline:none;background:#f8f8f8;-webkit-appearance:none;appearance:none;color:#000}' +
    '#bv-sb-inp:focus{border-color:#000;background:#fff}' +
    '#bv-sb-cls{width:36px;height:36px;border:none;background:none;display:flex;align-items:center;justify-content:center;cursor:pointer;color:rgba(0,0,0,.35);flex-shrink:0;-webkit-tap-highlight-color:transparent;padding:0}' +
    '#bv-footer{background:#111;padding:20px 16px 24px;box-sizing:border-box;width:100%}' +
    '.bv-ft-sec{border-bottom:0.5px solid rgba(255,255,255,.08);padding-bottom:14px;margin-bottom:14px}' +
    '.bv-ft-lbl{color:rgba(255,255,255,.35);font-size:7px;letter-spacing:2.5px;text-transform:uppercase;margin-bottom:8px}' +
    '.bv-ft-nl{display:flex;height:34px}' +
    '.bv-ft-nl input{flex:1;min-width:0;background:rgba(255,255,255,.07);border:0.5px solid rgba(255,255,255,.12);border-right:none;border-radius:3px 0 0 3px;padding:0 12px;color:rgba(255,255,255,.7);font-size:11px;outline:none;font-family:inherit;-webkit-appearance:none}' +
    '.bv-ft-nl input::placeholder{color:rgba(255,255,255,.3)}' +
    '.bv-ft-nl button{background:#fff;border:none;border-radius:0 3px 3px 0;padding:0 14px;font-size:9px;font-weight:700;letter-spacing:1px;text-transform:uppercase;cursor:pointer;color:#000;white-space:nowrap;-webkit-tap-highlight-color:transparent;flex-shrink:0}' +
    '.bv-ft-acc{border:0.5px solid rgba(255,255,255,.1);border-radius:4px;overflow:hidden;margin-bottom:14px}' +
    '.bv-ft-acc-row{display:flex;justify-content:space-between;align-items:center;padding:13px 14px;cursor:pointer;-webkit-tap-highlight-color:transparent;user-select:none;-webkit-user-select:none}' +
    '.bv-ft-acc-row+.bv-ft-acc-row{border-top:0.5px solid rgba(255,255,255,.07)}' +
    '.bv-ft-acc-lbl{color:rgba(255,255,255,.65);font-size:11px;font-weight:500;letter-spacing:.3px}' +
    '.bv-ft-acc-ico{color:rgba(255,255,255,.3);font-size:16px;line-height:1;transition:transform .2s;font-style:normal}' +
    '.bv-ft-acc-row.open .bv-ft-acc-ico{transform:rotate(45deg)}' +
    '.bv-ft-acc-body{max-height:0;overflow:hidden;transition:max-height .3s ease;background:rgba(255,255,255,.03)}' +
    '.bv-ft-acc-body.open{max-height:400px}' +
    '.bv-ft-acc-a{display:block;padding:10px 14px;color:rgba(255,255,255,.5);font-size:10px;text-decoration:none;border-top:0.5px solid rgba(255,255,255,.05);-webkit-tap-highlight-color:transparent}' +
    '.bv-ft-acc-a:active{background:rgba(255,255,255,.05)}' +
    '.bv-ft-pay{margin-bottom:14px;border-bottom:0.5px solid rgba(255,255,255,.08);padding-bottom:14px}' +
    '.bv-ft-pay-inner{display:flex;flex-wrap:wrap;gap:5px}' +
    '.bv-ft-pay-inner svg,.bv-ft-pay-inner img{height:22px;width:auto;border-radius:3px;background:rgba(255,255,255,.1);padding:2px 5px;display:block}' +
    '.bv-ft-bot{display:flex;justify-content:space-between;align-items:center}' +
    '.bv-ft-copy{color:rgba(255,255,255,.25);font-size:8px}' +
    '.bv-ft-soc{display:flex;gap:12px}' +
    '.bv-ft-soc a{color:rgba(255,255,255,.4);text-decoration:none;-webkit-tap-highlight-color:transparent;font-size:18px}';

  document.head.appendChild(s);

  /* CART SYNC — intercetta add-to-cart e aggiorna cart-items-component */
  (function () {
    var _fetch = window.fetch;
    window.fetch = function (input, init) {
      var url = typeof input === 'string' ? input : ((input && input.url) || '');
      var result = _fetch.apply(this, arguments);
      if (/\/cart\/add(\.js)?(\?|$)/.test(url)) {
        result.then(function (response) {
          if (!response.ok) return;
          var cartEl = document.querySelector('cart-items-component[data-section-id]');
          var sid = cartEl ? cartEl.getAttribute('data-section-id') : null;
          if (!sid) return;
          setTimeout(function () {
            _fetch('/?sections=' + encodeURIComponent(sid), { cache: 'no-store' })
              .then(function (r) { return r.json(); })
              .then(function (sections) {
                /* Sopprime auto-open: dispatchEvent è sincrono, ripristino subito dopo */
                var drw = document.querySelector('cart-drawer-component');
                var hadAO = drw && drw.hasAttribute('auto-open');
                if (hadAO) drw.removeAttribute('auto-open');
                document.dispatchEvent(new CustomEvent('cart:update', {
                  bubbles: true,
                  detail: { resource: null, sourceId: 'bv-cart-sync', data: { sections: sections } }
                }));
                if (hadAO) drw.setAttribute('auto-open', '');
              })
              .catch(function () {});
          }, 150);
        });
      }
      return result;
    };
  })();

  var lb = document.createElement('div');
  lb.id = 'bv-lb';
  document.body.appendChild(lb);
  var lbt = null;

  function lbStart() {
    clearTimeout(lbt);
    lb.style.transition = 'width .38s ease,opacity .25s ease';
    lb.style.width = '0%';
    lb.classList.add('on');
    requestAnimationFrame(function () {
      requestAnimationFrame(function () { lb.style.width = '62%'; });
    });
    lbt = setTimeout(function () { lb.style.width = '82%'; }, 500);
  }

  function lbDone() {
    clearTimeout(lbt);
    lb.style.transition = 'width .2s ease,opacity .3s ease';
    lb.style.width = '100%';
    setTimeout(function () {
      lb.classList.remove('on');
      setTimeout(function () { lb.style.transition = 'none'; lb.style.width = '0%'; }, 100);
    }, 220);
  }

  document.addEventListener('click', function (e) {
    var a = e.target.closest('a[href]');
    if (!a || a.target === '_blank') return;
    var h = a.getAttribute('href') || '';
    if (!h || h[0] === '#' || h.indexOf('javascript') === 0) return;
    if (a.getAttribute('onclick')) return;
    try {
      var u = new URL(a.href, location.href);
      if (u.hostname !== location.hostname) return;
    } catch (x) { return; }
    lbStart();
  }, { passive: true });

  window.addEventListener('pageshow', lbDone);
  document.addEventListener('DOMContentLoaded', lbDone);

  function initReveal() {
    var sel = '.product-card-wrapper,.product-card,.shopify-section .section';
    var SKIP = ['#bv-gallery','#bv-sticky-bar','#bv-wl-drawer','#bv-wl-trigger','.swipe-card','[id^="swipe-feed-container"]'];
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('bv-in'); io.unobserve(e.target); }
      });
    }, { threshold: 0.07, rootMargin: '0px 0px -28px 0px' });
    document.querySelectorAll(sel).forEach(function (el) {
      if (SKIP.some(function (sk) { return el.closest(sk); })) return;
      if (el.getBoundingClientRect().top < window.innerHeight * 0.8) return;
      el.classList.add('bv-rv');
      io.observe(el);
    });
  }

  var NAV = [
    { lbl: 'Home', url: '/' },
    { lbl: 'Best Sellers', url: '/collections/best-sellers' },
    { lbl: 'Donna', url: '/collections/donna', sub: [['Accessori','/collections/accessori'],['Borse','/collections/borse'],['Calze','/collections/calze'],['Cappelli','/collections/cappelli'],['Costumi','/collections/costumi'],['Felpe','/collections/felpe'],['Giacche','/collections/giacche'],['Gonne','/collections/gonne'],['T-shirt','/collections/magliette'],['Tute','/collections/tute'],['Scarpe','/collections/scarpe'],['Pantaloni','/collections/pantaloni'],['Pantaloncini','/collections/pantaloncini']]},
    { lbl: 'Uomo', url: '/collections/uomo', sub: [['Costumi','/collections/costumi-uomo'],['Felpe','/collections/felpa-uomo'],['T-shirt','/collections/tshirt-uomo'],['Scarpe','/collections/scarpe-uomo'],['Pantaloncini','/collections/pantaloncini-uomo'],['Pantaloni','/collections/pantaloni-uomo']]},
    { lbl: 'Brand', url: '/collections/guess', sub: [['Alexander McQueen','/collections/alexander-mcqueen'],['Dsquared','/collections/dsquared'],['Fendi','/collections/fendi'],['Gaelle','/collections/gaelle'],['GCDS','/collections/gcds'],['Guess','/collections/guess'],['Juicy Couture','/collections/juicy-couture'],['Mefui','/collections/mefui'],['Nosecrets','/collections/nosecrets-1'],['Disclaimer','/collections/disclaimer-donna'],['Karl Kani','/collections/karl-kani-ss26']]},
    { lbl: 'Outlet', url: '/collections/outlet', sub: [['777','/collections/777'],['Comme des Fuckdown','/collections/comme-des-fuckdown'],['Jijil','/collections/jijil'],['One Teaspoon','/collections/one-teaspoon'],['Versace Couture','/collections/versace-couture'],['Moschino','/collections/moschino'],['Balenciaga','/collections/balenciaga-1']]},
    { lbl: 'Gift Card', url: '/products/gift-card' },
    { lbl: 'Borgovitto Luxury Live', url: '/pages/borgovittoluxurylive' }
  ];

  function buildMenu() {
    var bd = document.createElement('div');
    bd.id = 'bv-menu-bd';
    bd.addEventListener('click', closeMenu);
    document.body.appendChild(bd);
    var panel = document.createElement('div');
    panel.id = 'bv-menu';
    panel.setAttribute('role', 'dialog');
    panel.setAttribute('aria-label', 'Navigazione');
    var hd = document.createElement('div');
    hd.id = 'bv-menu-hd';
    var logo = document.createElement('a');
    logo.id = 'bv-menu-logo';
    logo.href = '/';
    logo.textContent = 'Borgovitto';
    logo.addEventListener('click', closeMenu);
    var closeBtn = document.createElement('button');
    closeBtn.id = 'bv-menu-close';
    closeBtn.setAttribute('aria-label', 'Chiudi menu');
    closeBtn.innerHTML = '<svg width="14" height="14" viewBox="0 0 14 14" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"><line x1="1" y1="1" x2="13" y2="13"/><line x1="13" y1="1" x2="1" y2="13"/></svg>';
    closeBtn.addEventListener('click', closeMenu);
    hd.appendChild(logo);
    hd.appendChild(closeBtn);
    panel.appendChild(hd);
    var body = document.createElement('div');
    body.id = 'bv-menu-body';
    NAV.forEach(function (item) {
      if (item.sub && item.sub.length) {
        var row = document.createElement('div');
        row.className = 'bv-mi';
        var lbl = document.createElement('span');
        lbl.className = 'bv-mi-lbl';
        lbl.textContent = item.lbl;
        var ico = document.createElement('span');
        ico.className = 'bv-mi-ico';
        ico.textContent = '+';
        row.appendChild(lbl);
        row.appendChild(ico);
        var sub = document.createElement('div');
        sub.className = 'bv-sub';
        var allA = document.createElement('a');
        allA.className = 'bv-sub-a';
        allA.href = item.url;
        allA.textContent = 'Tutti — ' + item.lbl;
        allA.addEventListener('click', function () { closeMenu(); lbStart(); });
        sub.appendChild(allA);
        item.sub.forEach(function (si) {
          var a = document.createElement('a');
          a.className = 'bv-sub-a';
          a.href = si[1];
          a.textContent = si[0];
          a.addEventListener('click', function () { closeMenu(); lbStart(); });
          sub.appendChild(a);
        });
        row.addEventListener('click', function () {
          var isOpen = sub.classList.contains('open');
          document.querySelectorAll('#bv-menu-body .bv-sub.open').forEach(function (el) {
            el.classList.remove('open');
            if (el.previousElementSibling) el.previousElementSibling.classList.remove('expanded');
          });
          if (!isOpen) { sub.classList.add('open'); row.classList.add('expanded'); }
        });
        body.appendChild(row);
        body.appendChild(sub);
      } else {
        var a = document.createElement('a');
        a.className = 'bv-mi';
        a.href = item.url;
        a.innerHTML = '<span class="bv-mi-lbl">' + item.lbl + '</span>';
        a.addEventListener('click', function () { closeMenu(); lbStart(); });
        body.appendChild(a);
      }
    });
    var foot = document.createElement('div');
    foot.className = 'bv-mf';
    [['Account','/account'],['Contatti','/pages/contatti-1'],['Spedizioni','/pages/informative-sulle-spedizioni'],['Resi','/pages/informativa-su-resi-e-rimborsi']].forEach(function (fl) {
      var a = document.createElement('a');
      a.className = 'bv-mf-a';
      a.href = fl[1];
      a.textContent = fl[0];
      a.addEventListener('click', function () { closeMenu(); lbStart(); });
      foot.appendChild(a);
    });
    body.appendChild(foot);
    panel.appendChild(body);
    document.body.appendChild(panel);
  }

  function openMenu() {
    var p = document.getElementById('bv-menu');
    var bd = document.getElementById('bv-menu-bd');
    if (p) p.classList.add('open');
    if (bd) bd.classList.add('on');
    document.body.style.overflow = 'hidden';
    var btn = document.getElementById('bv-bn-menu');
    if (btn) btn.classList.add('cur');
  }

  function closeMenu() {
    var p = document.getElementById('bv-menu');
    var bd = document.getElementById('bv-menu-bd');
    if (p) p.classList.remove('open');
    if (bd) bd.classList.remove('on');
    document.body.style.overflow = '';
    var btn = document.getElementById('bv-bn-menu');
    if (btn) btn.classList.remove('cur');
  }

  function buildSearchBar() {
    var bar = document.createElement('div');
    bar.id = 'bv-sb';
    var inp = document.createElement('input');
    inp.id = 'bv-sb-inp';
    inp.type = 'search';
    inp.placeholder = 'Cerca prodotti...';
    inp.autocomplete = 'off';
    inp.setAttribute('autocorrect', 'off');
    inp.setAttribute('autocapitalize', 'none');
    inp.setAttribute('spellcheck', 'false');
    inp.addEventListener('keydown', function (e) {
      if (e.key === 'Enter' || e.keyCode === 13) {
        var q = inp.value.trim();
        if (q) { closeSearchBar(); lbStart(); location.href = '/search?q=' + encodeURIComponent(q) + '&type=product'; }
      }
    });
    var cls = document.createElement('button');
    cls.id = 'bv-sb-cls';
    cls.setAttribute('aria-label', 'Chiudi ricerca');
    cls.innerHTML = '<svg width="16" height="16" viewBox="0 0 16 16" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"><line x1="2" y1="2" x2="14" y2="14"/><line x1="14" y1="2" x2="2" y2="14"/></svg>';
    cls.addEventListener('click', closeSearchBar);
    bar.appendChild(inp);
    bar.appendChild(cls);
    document.body.appendChild(bar);
    document.addEventListener('touchstart', function (e) {
      var bar2 = document.getElementById('bv-sb');
      if (bar2 && bar2.classList.contains('open') && !bar2.contains(e.target)) {
        var searchBtn = document.getElementById('bv-bn-search');
        if (!searchBtn || !searchBtn.contains(e.target)) closeSearchBar();
      }
    }, { passive: true });
  }

  function openSearchBar() {
    var bar = document.getElementById('bv-sb');
    var inp = document.getElementById('bv-sb-inp');
    if (!bar) return;
    bar.classList.add('open');
    setTimeout(function () { if (inp) inp.focus(); }, 80);
    var btn = document.getElementById('bv-bn-search');
    if (btn) btn.classList.add('cur');
  }

  function closeSearchBar() {
    var bar = document.getElementById('bv-sb');
    if (!bar) return;
    bar.classList.remove('open');
    var inp = document.getElementById('bv-sb-inp');
    if (inp) inp.blur();
    var btn = document.getElementById('bv-bn-search');
    if (btn) btn.classList.remove('cur');
  }

  function triggerSearch() {
    closeMenu();
    var bar = document.getElementById('bv-sb');
    if (bar && bar.classList.contains('open')) { closeSearchBar(); } else { openSearchBar(); }
  }

  function triggerCart() {
    closeMenu();
    function openDrawer() {
      var btn = document.querySelector('cart-drawer-component button[on\\:click="/open"]');
      if (btn) { btn.click(); return; }
      var dlg = document.querySelector('cart-drawer-component dialog');
      if (dlg && dlg.showModal) { dlg.showModal(); return; }
      location.href = '/cart';
    }
    var cartEl = document.querySelector('cart-items-component[data-section-id]');
    var sid = cartEl ? cartEl.getAttribute('data-section-id') : null;
    if (sid) {
      fetch('/?sections=' + encodeURIComponent(sid), { cache: 'no-store' })
        .then(function (r) { return r.json(); })
        .then(function (sections) {
          var drw = document.querySelector('cart-drawer-component');
          var hadAO = drw && drw.hasAttribute('auto-open');
          if (hadAO) drw.removeAttribute('auto-open');
          document.dispatchEvent(new CustomEvent('cart:update', {
            bubbles: true,
            detail: { resource: null, sourceId: 'bv-cart-open', data: { sections: sections } }
          }));
          if (hadAO) drw.setAttribute('auto-open', '');
          openDrawer();
        })
        .catch(openDrawer);
    } else {
      openDrawer();
    }
  }

  function triggerWishlist() {
    closeMenu();
    if (window.bvWishlistOpen) window.bvWishlistOpen();
  }

  function initNav() {
    buildMenu();
    buildSearchBar();
    var path = location.pathname;
    function isActive(h) { return h === '/' ? path === '/' : path.indexOf(h) === 0; }
    var nav = document.createElement('nav');
    nav.id = 'bv-bn';
    nav.setAttribute('aria-label', 'Navigazione');
    var menuBtn = document.createElement('button');
    menuBtn.id = 'bv-bn-menu';
    menuBtn.className = 'bv-bn-a';
    menuBtn.setAttribute('aria-label', 'Menu');
    menuBtn.innerHTML = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round"><line x1="3" y1="6" x2="21" y2="6"/><line x1="3" y1="12" x2="21" y2="12"/><line x1="3" y1="18" x2="21" y2="18"/></svg><span>Menu</span>';
    menuBtn.addEventListener('click', openMenu, { passive: true });
    nav.appendChild(menuBtn);
    var searchBtn = document.createElement('button');
    searchBtn.id = 'bv-bn-search';
    searchBtn.className = 'bv-bn-a';
    searchBtn.setAttribute('aria-label', 'Cerca');
    searchBtn.innerHTML = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><circle cx="11" cy="11" r="8"/><line x1="21" y1="21" x2="16.65" y2="16.65"/></svg><span>Cerca</span>';
    searchBtn.addEventListener('click', triggerSearch, { passive: true });
    nav.appendChild(searchBtn);
    var wlBtn = document.createElement('button');
    wlBtn.id = 'bv-bn-wl';
    wlBtn.className = 'bv-bn-a';
    wlBtn.setAttribute('aria-label', 'Preferiti');
    wlBtn.innerHTML = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z"/></svg><span>Preferiti</span>';
    var wlBadge = document.createElement('span');
    wlBadge.className = 'bv-bn-b';
    wlBadge.id = 'bv-bn-wl-ct';
    wlBtn.appendChild(wlBadge);
    wlBtn.addEventListener('click', triggerWishlist, { passive: true });
    nav.appendChild(wlBtn);
    var cartBtn = document.createElement('button');
    cartBtn.className = 'bv-bn-a' + (isActive('/cart') ? ' cur' : '');
    cartBtn.setAttribute('aria-label', 'Carrello');
    cartBtn.innerHTML = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><path d="M6 2L3 6v14a2 2 0 002 2h14a2 2 0 002-2V6l-3-4z"/><line x1="3" y1="6" x2="21" y2="6"/><path d="M16 10a4 4 0 01-8 0"/></svg><span>Carrello</span>';
    var cartBadge = document.createElement('span');
    cartBadge.className = 'bv-bn-b';
    cartBadge.id = 'bv-bn-ct';
    cartBtn.appendChild(cartBadge);
    cartBtn.addEventListener('click', triggerCart, { passive: true });
    nav.appendChild(cartBtn);
    document.body.appendChild(nav);
    document.body.classList.add('bv-nb');
    function updCart() {
      fetch('/cart.js').then(function (r) { return r.json(); }).then(function (c) {
        var bd = document.getElementById('bv-bn-ct');
        if (!bd) return;
        var n = c.item_count || 0;
        bd.textContent = n > 9 ? '9+' : (n > 0 ? String(n) : '');
        bd.classList.toggle('on', n > 0);
      }).catch(function () {});
    }
    updCart();
    document.addEventListener('cart:update', updCart);
    function updWishlist() {
      try {
        var items = JSON.parse(localStorage.getItem('bv_wishlist_items') || '[]');
        var bd = document.getElementById('bv-bn-wl-ct');
        if (!bd) return;
        var n = items.length || 0;
        bd.textContent = n > 9 ? '9+' : (n > 0 ? String(n) : '');
        bd.classList.toggle('on', n > 0);
      } catch (e) {}
    }
    updWishlist();
    document.addEventListener('bv:wishlist:update', updWishlist);
    setInterval(updWishlist, 2000);
    setTimeout(function () {
      var trigger = document.getElementById('bv-wl-trigger');
      if (trigger) { trigger.style.display = 'none'; trigger.setAttribute('aria-hidden', 'true'); }
    }, 300);
  }

  function buildCustomFooter() {
    var origWrapper = document.querySelector('.section-wrapper:has(footer)') || document.querySelector('footer');
    if (!origWrapper) return;
    var ft = document.createElement('div');
    ft.id = 'bv-footer';
    var nlSec = document.createElement('div');
    nlSec.className = 'bv-ft-sec';
    var nlLbl = document.createElement('div');
    nlLbl.className = 'bv-ft-lbl';
    nlLbl.textContent = 'Newsletter';
    nlSec.appendChild(nlLbl);
    var nlForm = document.createElement('form');
    nlForm.method = 'post';
    nlForm.action = '/contact#ContactFooter';
    nlForm.innerHTML = '<input type="hidden" name="form_type" value="customer"><input type="hidden" name="utf8" value="✓"><input type="hidden" name="contact[tags]" value="newsletter">';
    var nlRow = document.createElement('div');
    nlRow.className = 'bv-ft-nl';
    var nlInp = document.createElement('input');
    nlInp.type = 'email';
    nlInp.name = 'contact[email]';
    nlInp.placeholder = 'La tua email';
    nlInp.required = true;
    var nlBtn = document.createElement('button');
    nlBtn.type = 'submit';
    nlBtn.textContent = 'Iscriviti';
    nlRow.appendChild(nlInp);
    nlRow.appendChild(nlBtn);
    nlForm.appendChild(nlRow);
    nlSec.appendChild(nlForm);
    ft.appendChild(nlSec);
    var INFO = [['Spedizioni','/pages/informative-sulle-spedizioni'],['Resi','/pages/informativa-su-resi-e-rimborsi'],['Contatti','/pages/contatti-1'],['Privacy','/policies/privacy-policy'],['Termini di servizio','/policies/terms-of-service'],['Cookie','/policies/legal-notice']];
    var accWrap = document.createElement('div');
    accWrap.className = 'bv-ft-acc';
    [['Info & Policy', INFO]].forEach(function (sec) {
      var row = document.createElement('div');
      row.className = 'bv-ft-acc-row';
      var lbl = document.createElement('span');
      lbl.className = 'bv-ft-acc-lbl';
      lbl.textContent = sec[0];
      var ico = document.createElement('span');
      ico.className = 'bv-ft-acc-ico';
      ico.textContent = '+';
      row.appendChild(lbl);
      row.appendChild(ico);
      var body = document.createElement('div');
      body.className = 'bv-ft-acc-body';
      sec[1].forEach(function (link) {
        var a = document.createElement('a');
        a.className = 'bv-ft-acc-a';
        a.href = link[1];
        a.textContent = link[0];
        body.appendChild(a);
      });
      row.addEventListener('click', function () {
        var isOpen = body.classList.contains('open');
        accWrap.querySelectorAll('.bv-ft-acc-body.open').forEach(function (b) {
          b.classList.remove('open');
          b.previousElementSibling.classList.remove('open');
        });
        if (!isOpen) { body.classList.add('open'); row.classList.add('open'); }
      });
      accWrap.appendChild(row);
      accWrap.appendChild(body);
    });
    ft.appendChild(accWrap);
    var origPay = origWrapper.querySelector('[class*="payment"]');
    if (origPay) {
      var payDiv = document.createElement('div');
      payDiv.className = 'bv-ft-pay';
      var payInner = document.createElement('div');
      payInner.className = 'bv-ft-pay-inner';
      payInner.appendChild(origPay.cloneNode(true));
      payDiv.appendChild(payInner);
      ft.appendChild(payDiv);
    }
    var bot = document.createElement('div');
    bot.className = 'bv-ft-bot';
    var copy = document.createElement('span');
    copy.className = 'bv-ft-copy';
    copy.textContent = '© ' + new Date().getFullYear() + ' Borgovitto';
    var soc = document.createElement('div');
    soc.className = 'bv-ft-soc';
    var origSocLinks = origWrapper.querySelectorAll('[class*="social"] a[href],[class*="social-link"] a[href]');
    if (origSocLinks.length) {
      origSocLinks.forEach(function (origA) {
        var href = (origA.href || '').toLowerCase();
        if (!href || href === '#') return;
        var icon = 'ti-external-link';
        if (href.includes('instagram')) icon = 'ti-brand-instagram';
        else if (href.includes('facebook')) icon = 'ti-brand-facebook';
        else if (href.includes('tiktok')) icon = 'ti-brand-tiktok';
        else if (href.includes('twitter') || href.includes('x.com')) icon = 'ti-brand-x';
        else if (href.includes('youtube')) icon = 'ti-brand-youtube';
        else if (href.includes('pinterest')) icon = 'ti-brand-pinterest';
        var a = document.createElement('a');
        a.href = origA.href;
        a.target = '_blank';
        a.rel = 'noopener noreferrer';
        a.innerHTML = '<i class="ti ' + icon + '" aria-hidden="true"></i>';
        soc.appendChild(a);
      });
    } else {
      [['https://www.instagram.com/','ti-brand-instagram'],['https://www.tiktok.com/','ti-brand-tiktok'],['https://www.facebook.com/','ti-brand-facebook']].forEach(function (s) {
        var a = document.createElement('a');
        a.href = s[0];
        a.target = '_blank';
        a.rel = 'noopener noreferrer';
        a.innerHTML = '<i class="ti ' + s[1] + '" aria-hidden="true"></i>';
        soc.appendChild(a);
      });
    }
    bot.appendChild(copy);
    bot.appendChild(soc);
    ft.appendChild(bot);
    origWrapper.parentNode.insertBefore(ft, origWrapper);
    origWrapper.style.display = 'none';
  }

  function vib(ms) { if (navigator.vibrate) navigator.vibrate(ms); }

  function initHaptic() {
    document.querySelectorAll('[name="add"],form[action="/cart/add"] button[type="submit"],.product-form__submit').forEach(function (b) {
      b.addEventListener('click', function () { vib(45); }, { passive: true });
    });
    var sb = document.getElementById('bv-sticky-atc');
    if (sb) sb.addEventListener('click', function () { vib(45); }, { passive: true });
    document.querySelectorAll('[id^="swipe-track-"]').forEach(function (t) {
      t.addEventListener('click', function (e) {
        if (e.target.closest('.swipe-card__btn--cart')) vib(45);
        if (e.target.closest('.swipe-card__side-btn')) vib(30);
      }, { passive: true });
    });
    var wl = document.getElementById('bv-wd-list');
    if (wl) wl.addEventListener('click', function (e) {
      if (e.target.closest('.bv-wd__btn--cart')) vib(45);
      if (e.target.closest('.bv-wd__btn--remove')) vib(25);
    }, { passive: true });
  }

  function initSkeleton() {
    document.querySelectorAll('.product-card img,[class*="product-card"] img,.card img').forEach(function (img) {
      if (img.complete && img.naturalWidth > 0) return;
      img.classList.add('bv-sk');
      img.addEventListener('load', function () { img.classList.remove('bv-sk'); }, { once: true });
      img.addEventListener('error', function () { img.classList.remove('bv-sk'); }, { once: true });
    });
  }

  function boot() { initReveal(); initNav(); initHaptic(); initSkeleton(); buildCustomFooter(); }
  if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', boot); }
  else { boot(); }

})();
